import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Code({
    item,
    className,
    interactionDisabled = true /* temporary in builder */,
}) {
    const { advanced = {} } = item;
    const { html = '' } = advanced;
    const regex = /<\/?script>?/gim;

    if (interactionDisabled && !html.trim()) {
        return (
            <div
                className={className}
                style={{
                    fontSize: 14,
                    color: '#ffffff',
                    padding: '20px',
                    fontStyle: 'italic',
                    textAlign: 'center',
                    borderRadius: '5px',
                    background: '#484B5E',
                }}
            >
                <FontAwesomeIcon icon={['far', 'laptop-code']} /> Custom HTML
                Block
            </div>
        );
    } else if (interactionDisabled && regex.test(html)) {
        return (
            <div
                className={className}
                style={{
                    fontSize: 14,
                    color: '#ffffff',
                    padding: '20px',
                    fontStyle: 'italic',
                    borderRadius: '5px',
                    background: '#484B5E',
                }}
            >
                <FontAwesomeIcon icon={['far', 'laptop-code']} /> This
                &lt;script&gt; embed will only appear on the published/exported
                site.
            </div>
        );
    } else {
        return (
            <div
                className={className}
                dangerouslySetInnerHTML={{ __html: html }}
            />
        );
    }
}

export default Code;
